import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
function DateComponent({ node, updateAttributes }) {
  const { id } = node.attrs;
  return (
    <NodeViewWrapper
      id={id} // ✅ CRITICAL
      data-placeholder-id={id}
      data-field-id={id}
      className="inline-flex items-center gap-2"
    >
      <input
        type="date"
        value={node.attrs.value || ''}
        onChange={(e) => updateAttributes({ value: e.target.value })}
        className="
  px-3 py-1.5 text-sm

  rounded-lg
  border border-slate-200
  bg-white

  shadow-sm

  transition

  hover:border-slate-300

  focus:outline-none
  focus:ring-2 focus:ring-[#375AE7]/20
  focus:border-[#375AE7]
"
      />
      {/* <div className="flex items-center gap-1 text-[10px] text-slate-400">
  <Calendar size={12} />
  <span>Date</span>
</div> */}
    </NodeViewWrapper>
  );
}

export const DateField = Node.create({
  name: 'dateField',

  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      id: { default: null },
      value: { default: '' },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(DateComponent);
  },

  parseHTML() {
    return [{ tag: 'dateField' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['dateField', mergeAttributes(HTMLAttributes)];
  },
});
